"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '0 0 15 16'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-210.000000, -6422.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(179.000000, 5953.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0.000000, 89.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(30.000000, 315.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1.000000, 64.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.25,14.5 C3.25251111,14.5 0,11.2474889 0,7.25 C0,3.25251111 3.25251111,0 7.25,0 C11.2474889,0 14.5,3.25251111 14.5,7.25 C14.5,11.2474889 11.2474889,14.5 7.25,14.5 Z M7.25,0.966666667 C3.78546667,0.966666667 0.966666667,3.78546667 0.966666667,7.25 C0.966666667,10.7145333 3.78546667,13.5333333 7.25,13.5333333 C10.7145333,13.5333333 13.5333333,10.7145333 13.5333333,7.25 C13.5333333,3.78546667 10.7145333,0.966666667 7.25,0.966666667 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.2705111,10.7544889 C10.1416222,10.7544889 10.0198222,10.7042222 9.92895556,10.6127111 L6.90844444,7.59155556 C6.86333333,7.54644444 6.82788889,7.4936 6.8034,7.43366667 C6.80146667,7.42851111 6.79953333,7.42271111 6.7976,7.41755556 C6.77697778,7.36213333 6.76731111,7.30671111 6.76731111,7.25 L6.76731111,4.83333333 C6.76731111,4.56653333 6.98384444,4.35 7.25064444,4.35 C7.51744444,4.35 7.73397778,4.56653333 7.73397778,4.83333333 L7.73397778,7.04957778 L10.6127111,9.92895556 C10.7042222,10.0204667 10.7544889,10.1416222 10.7544889,10.2705111 C10.7544889,10.3994 10.7042222,10.5212 10.6127111,10.6120667 C10.5212,10.7029333 10.3994,10.7544889 10.2705111,10.7544889 Z"
  })))))))));
});